export const LAST_APP_PAGE_VISITED_KEY = "LAST-APP_PAGE";
export const BASE_BACKEND_MEMBER_PATH = "/api/v0/member";
export const defaultListQueryOptions: ListQueryOptions = {
  page: 1,
  pageSize: 100,
  searchParams: null,
};

export const backendErrorCodes = {};
